module.exports = __webpack_public_path__ + "media/images/prismic_catalog/presentation_cards/subcategories/beauty-8df1d3d2259c658a4602a257bf3b8045.png";